var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceBathchair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.456,
    height: 59.189,
    viewBox: "0 0 59.456 59.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38753",
    "data-name": "\\uADF8\\uB8F9 38753",
    transform: "translate(-78.677 -110.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38752",
    "data-name": "\\uADF8\\uB8F9 38752",
    transform: "translate(83.29 128.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19486",
    "data-name": "\\uD328\\uC2A4 19486",
    d: "M95.085,151.794c-6,5-8.416,8.82-8.416,16.931a19.388,19.388,0,0,0,37.749,6.237",
    transform: "translate(-86.669 -150.778)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38755",
    "data-name": "\\uADF8\\uB8F9 38755",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 85.327, 140.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19486-2",
    "data-name": "\\uD328\\uC2A4 19486",
    d: "M106.066,188.122a19.389,19.389,0,0,0,18.352-13.16",
    transform: "translate(-86.669 -150.778)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19487",
    "data-name": "\\uD328\\uC2A4 19487",
    d: "M80.677,113.186H91.984c7.538,0,6.959,7.828,6.959,7.828s-.031,14.824,5.43,20.912,16.412,3.442,16.412,3.442",
    transform: "translate(0 -0.993)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceBathchair);
export default __webpack_public_path__ + "static/media/icon-service-bathchair.e1a3d2e8c3f7ca91798da7df8b9b39d0.svg";
export { ForwardRef as ReactComponent };